'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var credits = {
    enabled: false,
};
var title = {
    text: '',
};
var pane = {
    startAngle: 0,
    endAngle: 360,
    background: [
        {
            outerRadius: '100%',
            innerRadius: '85%',
            backgroundColor: 'rgba(227,235,246,1)',
            borderWidth: 0,
        },
    ],
};
var chartType = {
    type: 'solidgauge',
    marginTop: 0,
};
var plotOptions = {
    solidgauge: {
        dataLabels: {
            enabled: false,
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: true,
    },
};
var yAxis = {
    min: 0,
    max: 100,
    lineWidth: 0,
    tickPositions: [],
};

exports.chartType = chartType;
exports.credits = credits;
exports.pane = pane;
exports.plotOptions = plotOptions;
exports.title = title;
exports.yAxis = yAxis;
